module.exports = __webpack_public_path__ + "static/media/trial3_2.2e198bcd.png";